/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_4_DescInputs */

const en_mk_start_4_desc = /** @type {(inputs: Mk_Start_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every time you fix an agent’s output, save the rule into Company memory. The next agent reads it first, so the same mistake does not come back.`)
};

const id_mk_start_4_desc = /** @type {(inputs: Mk_Start_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap kali Anda memperbaiki hasil agen, simpan aturannya ke Memori perusahaan. Agen berikutnya membacanya lebih dulu, jadi kesalahan yang sama tidak terulang.`)
};

/**
* | output |
* | --- |
* | "Every time you fix an agent’s output, save the rule into Company memory. The next agent reads it first, so the same mistake does not come back." |
*
* @param {Mk_Start_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_4_desc = /** @type {((inputs?: Mk_Start_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_4_desc(inputs)
	return en_mk_start_4_desc(inputs)
});